'use client';

import { classNames } from '@bytel/product-wall/helpers';
import {
    Align,
    Column,
    Columns,
    Icon,
    IconName,
    IconSize,
    Text,
    TextLevels,
    TextMarkup,
    TrilogyColor,
    TypographyBold,
} from '@bytel/trilogy-react';

import { InlinePrice } from '@components/inline-price';

type StickyItemProps = {
    iconName: IconName;
    offerType: string;
    offerLabel?: string;
    period?: string;
    price?: number;
    className?: string;
};

export function StickyItem({ iconName, offerType, offerLabel, period, price, className }: Readonly<StickyItemProps>) {
    return (
        <Columns
            gap={1}
            verticalAlign={Align.CENTER}
            mobile
            className={classNames('is-spaced-between-mobile', className ?? '')}
        >
            <Column className='is-hidden-mobile' narrow>
                <Icon
                    name={iconName}
                    size={IconSize.SMALL}
                    circled
                    backgroundColor={TrilogyColor.INFO_FADE}
                    color={TrilogyColor.MAIN}
                />
            </Column>
            <Column narrow>
                <Text level={TextLevels.TWO} marginless typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                    {offerType}&nbsp;:
                </Text>
            </Column>
            <Column narrow>
                <Text level={TextLevels.TWO} marginless>
                    {offerLabel && price ? (
                        <>
                            <Text markup={TextMarkup.SPAN}>{offerLabel}</Text> (
                            <InlinePrice
                                level={TextLevels.TWO}
                                amount={price}
                                period={period}
                                typo={[TypographyBold.TEXT_WEIGHT_NORMAL]}
                            />
                            )
                        </>
                    ) : null}
                </Text>
            </Column>
        </Columns>
    );
}
